import { Col, Row } from "antd"
import servingIcon from '../../../../../../../assets/icons/servingIcon.svg'
import timeIcon from '../../../../../../../assets/icons/timeIcon.svg'

export const ViewRecipe = (props) => {
    // console.log(props);

    return (
        <div className="recipeModal">
            {/* {props.viewRecipeData &&  
            } */}
            <h5 className="mb-0">{props?.viewRecipeData?.name || ''}</h5>
            <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 8 }]} className="mt-3">

                {/* Servinng Size and Cooking Time */}
                {/* ============================================ */}
                <Col xs={24} md={24} xl={24} xxl={24}>
                    <div className="serving-size-time">
                        <div><img src={servingIcon} alt="" />
                            Serving size -
                            <span id="serving-size">{props?.viewRecipeData?.serving_size || ''}</span> people
                        </div>
                        <div><img src={timeIcon} alt="" />
                            Cooking time - <span id="cooking-time">{props?.viewRecipeData?.time_for_preparation || ''}</span>
                        </div>
                    </div>
                </Col>

                {/* Ingredient Item Name List With Detail */}
                {/* ============================================ */}
                <Col xs={24} md={24} xl={24} xxl={24}>
                    <div className="recipe-ingradient-list-modal">
                        <div className="recipe-mdal-heading">Ingredients Details</div>
                        <p id="ingredients">
                            <ul className="list-unstyled m-0 border-0 mb-0">
                                {props?.viewRecipeData?.recipe_ingredient &&
                                    props?.viewRecipeData?.recipe_ingredient.length > 0 &&
                                    props?.viewRecipeData?.recipe_ingredient.map((ingredientRecord, ingredientRecordIndex) =>
                                        <li key={ingredientRecordIndex}>{ingredientRecordIndex + 1 + ') ' +
                                            ingredientRecord?.gram} Grams ({ingredientRecord?.ingredients_form?.name})
                                            {' ' + ingredientRecord?.ingredient?.name}
                                        </li>
                                    )}
                            </ul>
                        </p>
                    </div>
                </Col>

                {/* Preparation Steps for Recipe With Detail */}
                {/* ============================================ */}
                <Col xs={24} md={24} xl={24} xxl={24}>
                    <div className="recipe-ingradient-list-modal">
                        <div className="recipe-mdal-heading">Recipe method</div>
                        <ul className="list-unstyled mb-0">
                            {props?.viewRecipeData?.preparation_steps &&
                                props?.viewRecipeData?.preparation_steps.length > 0 &&
                                JSON.parse(props?.viewRecipeData?.preparation_steps).map((preparaionStep, preparaionStepIndex) =>
                                    <li key={preparaionStepIndex}>{preparaionStepIndex + 1 + ') ' + preparaionStep} </li>
                                )}
                        </ul>
                    </div>
                </Col>

                {/* Total Micros List Of Recipe */}
                {/* ============================================ */}
                <Col xs={24} md={24} xl={24} xxl={24}>
                    <div className="recipe-ingradient-list-modal micro-mdl-list mb-4">
                        <div className="recipe-mdal-heading">Micros</div>
                        <ul className="list-unstyled macrosList" id="micros">
                            {props?.viewRecipeData?.recipe_macros_micros &&
                                props?.viewRecipeData?.recipe_macros_micros.length > 0 &&
                                props?.viewRecipeData?.recipe_macros_micros.map((ingredientMacro, ingredientMacroIndex) =>
                                    <li key={ingredientMacroIndex}>{ingredientMacro?.name} - {parseFloat(ingredientMacro?.total).toFixed(2)} {ingredientMacro?.unit}</li>
                                )}
                        </ul>
                    </div>
                </Col>
            </Row>
        </div>
        // static backup code
        // <div className="recipeModal">
        //     <h5 className="mb-0">Beetroot Chutney</h5>
        //     <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 8 }]} className="mt-3">
        //         <Col xs={24} md={24} xl={11} xxl={24}>
        //             <div className="serving-size-time">
        //                 <div><img src={servingIcon} alt="" />
        //                     Serving size -
        //                     <span id="serving-size">1</span> people
        //                 </div>
        //                 <div><img src={timeIcon} alt="" />
        //                     Cooking time - <span id="cooking-time">15 min</span>
        //                 </div>
        //             </div>
        //         </Col>
        //         <Col xs={24} md={24} xl={11} xxl={24}>

        //             <div className="recipe-ingradient-list-modal">
        //                 <div className="recipe-mdal-heading">Ingredients Details</div>
        //                 <p id="ingredients">
        //                     <pre>
        //                         1) 50 Grams (Chopped) Beet root<br />
        //                         2) 5 Grams (Chopped) Chillies, green - all varieties<br />
        //                         3) 5 Milliliter (Prepared) Lemon, juice<br />
        //                         4) 2 Grams (Prepared) ROCK SALT<br />
        //                         5) 5 Grams (Chopped) Ginger, fresh<br />
        //                         6) 2 Grams (Powdered) Cumin seeds<br />
        //                     </pre>
        //                 </p>
        //             </div>
        //         </Col>
        //         <Col xs={24} md={24} xl={11} xxl={24}>
        //             <div className="recipe-ingradient-list-modal">
        //                 <div className="recipe-mdal-heading">Recipe method</div>
        //                 <p id="method" className="pre-text">
        //                     1) In a blender or chutney grinder, add chopped fresh beetroot, ginger and green chili. Add lemon juice, cumin powder and salt as required. <br />
        //                     2) With some water blend or grind all the ingredients in a blender or chutney grinder or magic bullet till smooth.<br />
        //                     3) Check the seasoning and add more salt or lemon juice if required. Store the chutney in a covered bowl or container in the refrigerator.<br />
        //                 </p>
        //             </div>
        //         </Col>
        //         <Col xs={24} md={24} xl={11} xxl={24}>
        //             <div className="recipe-ingradient-list-modal micro-mdl-list mb-4">
        //                 <div className="recipe-mdal-heading">Micros</div>
        //                 <ul  className="list-unstyled" id="micros"><li>Vitamin A - 0µg</li><li>Ascorbic acids (C) - 0mg</li><li>Vitamin D - 0µg</li><li>α -Tocopherol equivalent (E) - 0.11mg</li><li>Vitamin K - 0µg</li><li>Thiamine (B1) - 0.02mg</li><li>Riboflavin (B2) - 0.02mg</li><li>Total B6 - 0mg</li><li>Folates (B9) - 0µg</li><li>Calcium (Ca) - 0.04mg</li><li>Iron (Fe) - 0mg</li><li>Phophorus (P) - 0.03mg</li><li>Potassium (K) - 0.24mg</li><li>Sodium (Na) - 190.03mg</li><li>Zinc (Zn) - 0.26mg</li></ul>
        //             </div>
        //         </Col>
        //     </Row>
        // </div>
    )
}